import { Component, OnInit, PLATFORM_ID, Inject, HostListener, AfterViewInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError, Event } from '@angular/router';
//services
import { HttpService } from 'src/app/services/http.service';
import { StoreService } from 'src/app/services/store.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SharedService } from './services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title: string;
  isloading: boolean = false;
  route_path: string;
  resFavicon : any;
  isLocationSelected: boolean = false;
  private readonly LOCATIONS_REFRESH_INTERVAL = 10 * 60 * 1000; // 15 minutes
  private locationRefreshTimer: any;

  restaurantLocationsData: any;

  data: any;
  // isShowOrderBtn: boolean = false;

  isCheckoutPage: boolean = false;
  hiddenRoutes = [
  'choose-location',
  'order-online',
  'order-online/checkout',
  'order-confirmation',
  'user-order-track',
  'user-booking-track',
  'sign-in',
  'sign-up',
  'verify-account',
  'forget-password',
  'reset-password',
  'my-account',
  'my-setting',
  'my-order',
  'my-reservation',
  'my-review',
  'my-loyalty',
  'my-favourite',
  'manage-reservation',
  'gift-voucher',
  'gift-voucher-confirmation',
  'error-page',
  'payment',
  'glorydeal',
];

allowedRedirectRoutes: string[] = [
  'faq',
  'gdpr-statement',
  'privacy-policy',
  'terms-conditions',
  'choose-location'
];

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    private router: Router,
    public cdr: ChangeDetectorRef,
    private httpService: HttpService,
    private storeService: StoreService,
    private loadingService: LoadingService,
    private renderer: Renderer2,
    private sharedService: SharedService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
          this.loadingService.loadingStart();
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.route_path = event.url.replace('/', '');
          if(this.route_path === 'order-online/checkout'){
            this.isCheckoutPage = true;
          }
          setTimeout(() => {
            this.loadingService.loadingClose();
          }, 2000);
        }
      });
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)){
      this.preventZoom();
      //  get saved restaurant content data by restaurant id  
      if(sessionStorage.getItem('restaurant_id')){
        this.getRestaurantContent(sessionStorage.getItem('restaurant_id'));
      }
      this.ensureFreshRestaurantLocations();
      this.startLocationsRefreshTimer();
      this.setDynamicFavicon();
    }
  }
  

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)){
      this.loadingService.loading$.subscribe((val) => {
        this.isloading = val;
        this.cdr.detectChanges();
      })

      if(this.storeService.restaurantData){
        this.data = this.storeService.restaurantData;
          this.data.subscribe(result => {
          if (Object.getOwnPropertyNames(result).length !== 0) {
            if(result){
              this.isLocationSelected = true;
            }
          }
        });
      }
    }
  }


  getChainRestaurantsByHostName(isBackgroundRefresh: boolean = false) {
    if (isPlatformBrowser(this.platformId)) {
      if (!isBackgroundRefresh) {
        this.loadingService.loadingStart();
      }
      this.httpService.getChainRestaurantsByHostName().subscribe((result: any) => {
        this.persistLocationsData(result);

        if (!isBackgroundRefresh && !this.allowedRedirectRoutes.includes(this.route_path)) {
          this.router.navigate(['/']);
        }
        if (!isBackgroundRefresh) {
          setTimeout(() => {
            this.loadingService.loadingClose();
          }, 2000);
        }
      }, err => {
        if (!isBackgroundRefresh) {
          this.loadingService.loadingClose();
          this.router.navigate(['/network-error']);
        }
      });
    }
  }

  getRestaurantContent(resId: any){
    if (isPlatformBrowser(this.platformId)) {
      this.httpService.getRestaurantContent(resId).subscribe(res => {
        this.storeService.saveRestaurantData(res);
        this.resFavicon = res?.restaurant_data?.favicon;
      })
    }
  }

  onActivate() {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      document.querySelector('body').style.removeProperty('overflow');
    }
  }

  setDynamicFavicon() {
    const faviconLink = document.getElementById('dynamicFavicon') as HTMLLinkElement;
    const dynamicFaviconPath = this.resFavicon ? this.resFavicon : '../favicon.ico';

    if (faviconLink) {
      faviconLink.href = dynamicFaviconPath;
    } else {
      // If the link element doesn't exist, create and append it to the document head
      const newFaviconLink = document.createElement('link');
      newFaviconLink.id = 'dynamicFavicon';
      newFaviconLink.rel = 'icon';
      newFaviconLink.type = 'image/x-icon';
      newFaviconLink.href = dynamicFaviconPath;

      document.head.appendChild(newFaviconLink);
    }
  }

  preventZoom() {
    // Prevent double-tap to zoom
    this.renderer.listen('document', 'dblclick', (event: MouseEvent) => {
      event.preventDefault();
    });
  }

  onOrderOnlineClickedForRouting(){
      this.restaurantLocationsData = JSON.parse(sessionStorage.getItem('restaurantLocationDatas'));
      this.sharedService.setLocationsData(this.restaurantLocationsData);

      if(this.isLocationSelected){
        this.router.navigateByUrl("/order-online")
      }else {
        this.router.navigateByUrl("/choose-location")
      }
    }

  shouldShowOrderNowButton(): boolean {
    return !this.hiddenRoutes?.some(path => this.route_path?.includes(path));
  }

  private ensureFreshRestaurantLocations(): void {
    const storedLocations = sessionStorage.getItem('restaurantLocationDatas');
    // Always refresh on load;
    this.getChainRestaurantsByHostName(!!storedLocations);
    if (storedLocations) {
      this.updateSelectedRestaurantFromLocations(JSON.parse(storedLocations));
    }
  }

  private startLocationsRefreshTimer(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.locationRefreshTimer) clearInterval(this.locationRefreshTimer);

    this.locationRefreshTimer = setInterval(() => {
      this.getChainRestaurantsByHostName(true);
    }, this.LOCATIONS_REFRESH_INTERVAL);
  }

  private persistLocationsData(result: any): void {
    if (!result) return;

    sessionStorage.setItem('restaurantLocationDatas', JSON.stringify(result));
    sessionStorage.setItem('restaurantLocationDatasFetchedAt', Date.now().toString());
    this.sharedService.setLocationsData(result);
    this.updateSelectedRestaurantFromLocations(result);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('restaurantLocationsUpdated', { detail: result }));
    }
  }

  private updateSelectedRestaurantFromLocations(locations: any[]): void {
    if (!locations || locations.length === 0) return;
    const selectedStr = sessionStorage.getItem('selected_restaurant_data');
    if (!selectedStr) return;

    const selected = JSON.parse(selectedStr);
    const matched = locations.find(loc => loc?.restaurant_id === selected?.restaurant_id);

    if (matched) {
      const updatedSelection = this.appendBrandAndLocation(matched, selected);
      sessionStorage.setItem('selected_restaurant_data', JSON.stringify(updatedSelection));

      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('selectedRestaurantDataUpdated', { detail: updatedSelection }));
      }
    }
  }

  private appendBrandAndLocation(current: any, fallback: any) {
    const [brand, location] = current?.restaurant_name ? current.restaurant_name.split('?').map((part: string) => part.trim()) : [null, null];
    return {
      ...current,
      brandName: brand ? `${brand}?` : fallback?.brandName,
      locationName: location || fallback?.locationName
    };
  }

}
